import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import config from "./config";
import "./App.css";

const EnterCar = () => {
    const [licensePlate, setLicensePlate] = useState("");
    const [siteName, setSiteName] = useState("טוען...");
    const [error, setError] = useState("");
    const [info, setInfo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [clock, setClock] = useState(""); // State for the clock
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [paymentCompany, setPaymentCompany] = useState("");
    const [payplusCustomer, setPayplusCustomer] = useState({});
    const [withPayment, setWithPayment] = useState(1);
    const [withQr, setWithQr] = useState(1);
    const [paymentDiscount, setPaymentDiscount] = useState(0);
    const [subscriptionPlaces, setSubscriptionPlaces] = useState([]);
    const [selectedSubscriptionPlaceId, setSelectedSubscriptionPlaceId] = useState("");
    useEffect(() => {
        const guid = searchParams.get("guid");
        localStorage.setItem('guid', guid);
        if (!guid) {
            setError(" חסר מיקום חזרה לעמוד הראשי...");
            setTimeout(() => navigate("/", { replace: true }), 3000);
            return;
        }

        fetch(`${config.apiUrl}/validateGuid?guid=${guid}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("מיקום לא תקין");
                }
                return response.json();
            })
            .then((data) => {
                if(!data.active){
                    throw new Error("עמדה לא פעילה");
                }
                else {
                    if (data.displayName) {
                        setSiteName(data.displayName);
                        setPaymentCompany(data.paymentCompany);
                        setPayplusCustomer(data.payplusCustomer);
                        setWithPayment(data.withPayment);
                        setWithQr(data.withQr);
                        setPaymentDiscount(data.payment_discount);
                        localStorage.setItem('placeId', data.placeId);
                        const places = Array.isArray(data.subscriptionPlaces) && data.subscriptionPlaces.length
                            ? data.subscriptionPlaces
                            : (data.subscriptionPlaceId ? [{ id: data.subscriptionPlaceId, name: data.subscriptionPlaceName || "" }] : []);
                        localStorage.setItem('subscriptionPlaces', JSON.stringify(places));
                        setSubscriptionPlaces(places);
                        setSelectedSubscriptionPlaceId(places[0]?.id || "");
                        localStorage.setItem('PaymentDiscount', data.payment_discount);
                        localStorage.setItem('graceTimeOffset', data.graceTimeOffset);
                        localStorage.setItem('siteName', data.displayName);
                    } else {
                        throw new Error("מיקום לא תקין");
                    }
                }
            })
            .catch((err) => {
                if(err.message === 'עמדה לא פעילה') {
                navigate('/error')
                }
                else {
                    setError("מיקום לא תקין. חזרה לעמוד הראשי...");
                    setTimeout(() => navigate("/", {replace: true}), 3000);
                }
            });
    }, [navigate, searchParams]);

    const handleGoToSubscription = (placeId) => {
        if (!placeId) return;
        window.location.href = `https://subscription.bluept.cloud/subscription?place-id=${encodeURIComponent(placeId)}`;
    };

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            setClock(now.toLocaleTimeString("en-GB")); // Update clock in 24-hour format
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const handleNumberClick = (num) => {
        setLicensePlate((prev) => prev + num);
    };

    const handleClear = () => {
        setLicensePlate("");
    };

    const handleDelete = () => {
        setLicensePlate((prev) => prev.slice(0, -1));
    };

    const handleContinue = () => {
        const guid = searchParams.get("guid");

        if (!licensePlate) {
            setError("אנא הזינו מספר רכב");
            return;
        }

        if (licensePlate.length < 5 || licensePlate.length > 8) {
            setError("מספר רכב צריך להיות בין 5 ל-8 ספרות. אנא הזינו שוב.");
            return;
        }
        setInfo(false);
        setError("");
        setIsLoading(true);

        fetch(`${config.rtc.serverUrl}/get-car-info`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                deviceguid: guid,
                plate: licensePlate,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Error fetching payment amount");
                }
                return response.json();
            })
            .then((data) => {
                const jsonDataStart = data.data.indexOf("info:") + 5;
                const jsonPart = data.data.slice(jsonDataStart).trim();

                const extractedData = JSON.parse(jsonPart);

                const extractedInfo = JSON.parse(extractedData.info);



                if (extractedInfo.Reason==='in free time') {
                    setInfo(true);
                    setIsLoading(false);
                    return;
                }

                if (config.invalidPaymentReasons.includes(extractedInfo.Reason)) {
                    setError(`לא ניתן לשלם עבור רכב ${licensePlate}. נסו שנית או שלמו בעמדת היציאה.`);
                    setIsLoading(false);
                    return;
                }
                // if(extractedInfo.Price && extractedInfo.Price<=paymentDiscount ) {
                //     localStorage.setItem("amountToPay", extractedInfo.Price);
                //     navigate("/completion", {
                //         state: { code: "999999999", plate: licensePlate, deviceguid: guid, paymentDiscount, price: extractedInfo.Price  },
                //     });
                //     return;
                // }
                if (extractedInfo.Price !== undefined) {
                    localStorage.setItem("userIdFromPal", extractedInfo.UserId);
                    navigate(
                        `/view-payment?guid=${guid}&plate=${licensePlate}&amount=${extractedInfo.Price}&stayTime=${extractedInfo.StayTime}`,
                        {
                            state: {from: "/enter-car", paymentCompany, siteName, withPayment, paymentDiscount, withQr},
                        });
                } else {
                    throw new Error("No payment data received");
                }
            })
            .catch((err) => {
                console.error("Error fetching payment amount:", err);
                setError("שגיאה בשליפת הנתונים. אנא נסו שוב.");
                setIsLoading(false);
            });
    };

    return (
        <div style={{            position: "relative",
            width: "100vw",      // ← full viewport width
            height: "100vh",     // ← full viewport height
            margin: 0,
            background: "#FFFFFF",
            overflow: "hidden",
            direction: "rtl",
             display:       "flex",
             flexDirection: "column",      // stack children vertically
             justifyContent:"center",  // start at the top
             alignItems:    "center",      // still center horizontally

        }}>
            <button className="back-button" onClick={() => navigate(-1)}>
                <img
                    src={`${process.env.PUBLIC_URL}/arrow.png`}
                    alt="חץ אחורה"
                    className="arrow-icon"
                />
            </button>

            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // marginTop: "10%",
                flexDirection: "column"
            }}>
                <svg style={{ flexShrink: 0, marginBottom: 16 }} width="54" height="51" viewBox="0 0 54 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M42.3661 33.2957C42.7059 33.95 42.8947 34.6427 42.8947 35.4125V35.5664C42.8947 38.1066 40.8558 40.2235 38.3262 40.2235H21.0716C18.1644 40.2235 15.7858 42.6482 15.7858 45.6117C15.7858 48.5753 18.1644 51 21.0716 51H38.3262C46.6703 51 53.4286 44.1107 53.4286 35.6049V35.451C53.4286 32.218 52.447 29.216 50.7479 26.7143C48.6336 29.6778 45.7264 31.9871 42.3661 33.3342"
                        fill="#0497CD"/>
                    <path
                        d="M5.2937 51C2.38217 51 0 48.6297 0 45.7241V0H38.2659C46.6224 0 53.4286 6.84333 53.4286 15.3306V15.407C53.4286 23.8561 46.6602 30.7376 38.2659 30.7376H23.9729C21.137 30.7376 18.6792 28.5967 18.4901 25.7294C18.3011 22.6327 20.7211 20.0712 23.746 20.0712H38.2281C40.7615 20.0712 42.8034 18.0067 42.8034 15.4453V15.3688C42.8034 12.8073 40.7615 10.7429 38.2281 10.7429H10.5118L10.6252 45.6094C10.6252 48.5532 8.31867 50.9618 5.40714 51C5.40714 51 5.36933 51 5.33151 51"
                        fill="#003C6B"/>
                </svg>


                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        padding: "0 0 12px",
                        gap: "15px",
                        // marginTop: "20%",
                        width: 390,
                        height: 461,

                        flex: "none",        // equivalent to flex: 0 0 auto
                        order: 0,
                        alignSelf: "stretch",
                        flexGrow: 0,
                    }}
                >

                    <h3 style={{
                        fontFamily: "Heebo",
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: 18,         // px
                        lineHeight: "27px",
                        textAlign: "center",
                        color: "#173E6B",
                    }}>
                        הינכם נמצאים בחניון: <br/>
                        <span style={{
                            /* button */

                            boxSizing: "border-box",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "9px 15px",
                            gap: "40px",

                            width: "332px",
                            height: "45px",

                            background: "#FFFFFF",
                            border: "1px solid #0098CF",
                            borderRadius: "10px",
                            color: "#0098CF",
                            fontFamily: 'Heebo',
                            fontStyle: "normal",
                            fontWeight: 700,
                            fontSize: "16px",
                            lineHeight: "24px",
                            /* Inside auto layout */
                            flex: "none",
                            order: "1",
                            flexGrow: "0",
                        }}>{siteName}</span>
                    </h3>
                    <div style={{marginTop: 10,     fontFamily: 'Heebo',}}>
                        *שימו לב - נא לבצע את התשלום לפני החזרה לרכב
                    </div>
                    {error && <span style={{
                        fontFamily: "Heebo",
                        fontStyle: "normal",
                        maxWidth: "80%", // limit width to prevent overflow
                        fontWeight: 400,
                        fontSize: 18,         // px
                        lineHeight: "27px",
                        textAlign: "center",
                        color: "red",
                    }}>{error}</span>
                    }
                    {info && <span style={{
                        fontFamily: "Heebo",
                        fontStyle: "normal",
                        maxWidth: "80%", // limit width to prevent overflow
                        fontWeight: 400,
                        fontSize: 18,         // px
                        lineHeight: "27px",
                        textAlign: "center",
                        color: "green",
                    }}>>אין צורך בתשלום עבור רכב זה</span>}

                    <span
                        style={{
                            display: "flex",
                            justifyContent: "center",     // center text horizontally
                            alignItems: "center",     // center text vertically
                            width: 230,          // px
                            height: 18,           // px
                            marginTop: "20px",
                            fontFamily: "Heebo",
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: 18,           // px
                            lineHeight: "27px",
                            textAlign: "center",
                            color: "#173E6B",

                            /* Inside auto layout */
                            flex: "none",       // same as flex: 0 0 auto
                            order: 0,
                            flexGrow: 0,
                        }}
                    >
        אנא הכניסו מספר רכב:
</span>
                    <div>
                        <input
                            id="license-plate"
                            className="input"
                            type="tel"                    /* “tel” forces a phone-style keypad */
                            inputMode="numeric"           /* hint: only digits */
                            pattern="[0-9]*"              /* further hint & basic validation */
                            onChange={(e) => setLicensePlate(e.target.value)}
                            value={licensePlate}
                            placeholder="הכניסו מספר רכב"
                            style={{
                                width: "100%",
                                padding: "8px",
                                boxSizing: "border-box",
                                direction: "rtl",       // RTL input behavior
                                textAlign: "right",     // placeholder & typed text align right
                                color: "#0098CF",
                                fontFamily: 'Heebo',
                                fontStyle: "normal",
                                fontWeight: "700",
                                fontSize: "16px",
                                lineHeight: "24px",
                            }}
                        />

                        <button
                            style={{
                                display: "block",
                                width: 333,
                                height: 45,
                                margin: "0 auto 24px",
                                border: "none",
                                borderRadius: 10,
                                background:
                                    "linear-gradient(90deg, #DEF7FF -11.26%, #0098CF 34.16%, #173E6B 100%)",
                                boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                                cursor: "pointer",
                                marginTop: "20px",


                                fontFamily: "Heebo",
                                fontStyle: "normal",
                                fontWeight: 900,
                                fontSize: 19,              // px
                                lineHeight: "28px",        // exact px height
                                // textAlign: "right",

                                color: "#FFFFFF",

                                /* Inside auto layout */
                                // flex: "none",              // same as flex: 0 0 auto
                                order: 0,
                                flexGrow: 0,

                            }} onClick={handleContinue}
                            disabled={isLoading}

                        >
                            {isLoading ? <div className="spinner"></div> : "המשך"}
                        </button>

                        {subscriptionPlaces.length > 1 && (
                            <div
                                style={{
                                    width: 333,
                                    margin: "0 auto 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                    direction: "rtl",
                                }}
                            >
                                <label
                                    htmlFor="subscription-place"
                                    style={{
                                        fontFamily: "Heebo",
                                        fontWeight: 700,
                                        fontSize: 18,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    בחר חניון
                                </label>
                                <select
                                    id="subscription-place"
                                    value={selectedSubscriptionPlaceId}
                                    onChange={(event) => setSelectedSubscriptionPlaceId(event.target.value)}
                                    style={{
                                        flex: 1,
                                        minWidth: 0,
                                        height: 45,
                                        padding: "0 12px",
                                        border: "1px solid #0098CF",
                                        borderRadius: 10,
                                        background: "#FFFFFF",
                                        fontFamily: "Heebo",
                                        fontSize: 16,
                                        direction: "rtl",
                                    }}
                                >
                                    {subscriptionPlaces.map((place) => (
                                        <option key={place.id} value={place.id}>
                                            {place.name || place.id}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {subscriptionPlaces.length > 0 && (
                            <button
                                style={{
                                    display: "block",
                                    width: 333,
                                    minHeight: 45,
                                    height: "auto",
                                    margin: "0 auto 24px",
                                    border: "none",
                                    borderRadius: 10,
                                    background:
                                        "linear-gradient(90deg, #DEF7FF -11.26%, #0098CF 34.16%, #173E6B 100%)",
                                    boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                                    cursor: "pointer",
                                    marginTop: "0px",
                                    fontFamily: "Heebo",
                                    fontStyle: "normal",
                                    fontWeight: 900,
                                    fontSize: 19,
                                    lineHeight: "28px",
                                    padding: "8px 14px",
                                    whiteSpace: "normal",
                                    overflowWrap: "anywhere",
                                    color: "#FFFFFF",
                                    order: 0,
                                    flexGrow: 0,
                                }}
                                onClick={() => handleGoToSubscription(
                                    subscriptionPlaces.length === 1
                                        ? subscriptionPlaces[0].id
                                        : selectedSubscriptionPlaceId
                                )}
                            >
                                לרכישת מנוי
                            </button>
                        )}

                    </div>
                </div>
                {/* Footer Section */}  </div>
            <img
                src="/bIcon.jpeg"
                alt=""
                style={{
                        position: "absolute",
                        marginTop: "45%",                     // nudge down from the top of footer
                        left: "50%",
                        transform: "translateX(-50%) rotate(-45deg)",
                    width: "100vh",                  // match your design scale
                    opacity: 0.05,               // very faint
                    pointerEvents: "none",
                    zIndex: 0,
                }}
            />
            <footer
                style={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    height: 150,                  // give it enough room for the icon
                    overflow: "hidden",
                    borderTopLeftRadius: 22,
                    borderTopRightRadius: 22,
                    background: "rgba(0,152,207,0.23)",
                    boxShadow: "0px 4px 13px rgba(8,25,40,0.22)",
                }}
            >
                <div style={{
                    width: 333,
                    margin: "0 auto",
                    display: "flex",
                    justifyContent:"center",
                    alignItems: "center",
                    marginTop: "20px",
                    flexDirection: "column",
                    gap: 6,
                }}>
                    <p>
                        מספר רכב נוכחי: <span >{licensePlate || "לא הוזן"}</span>
                    </p>
                    <p>
                        שעה נוכחית:{" "}
                        <span>{clock}</span>
                    </p>
                    <p>&copy; {new Date().getFullYear()} BluePT</p>
                    <Link to="/privacy-policy" style={{ margin: 0, color: "#0098CF", fontSize: 12, textDecoration: "underline" }}>
                        מדיניות פרטיות
                    </Link>
                </div>
            </footer>
        </div>
    );
};

export default EnterCar;
